import React from 'react';
import { gql } from '@apollo/client';
import { Datagrid } from 'react-admin';
import List from 'components/List';
import PositionInput from 'components/PositionInput';
import LinkField from 'components/LinkField';
import BulkUploadButtons from 'components/BulkUploadButtons';
import MoneyField from 'components/MoneyField';
import useGate from 'hooks/useGate';
import { gateNames } from 'constants/statsig';
import { IdFilter } from 'components/Filter';

const AgencyLocationPositionRateSettingListFilters = [
  <IdFilter />,
  <PositionInput emptyText="All" alwaysOn />,
  <IdFilter label="Location ID" source="location_id" alwaysOn />,
  <IdFilter label="Agency ID" source="agency_id" alwaysOn />,
];

const bulkUploadButtons = (
  <BulkUploadButtons
    downloadUrl="https://medely-public-files.s3.us-west-2.amazonaws.com/csv_templates/agency_location_position_rate_settings_template.csv"
    uploadUrl="v3/admin/agency_location_position_rate_settings/import"
  />
);

const AgencyLocationPositionRateSettingList = () => {
  const { value: blockCreateRateSettings } = useGate(gateNames.blockCreateNewRateSettings);

  return (
    <List
      filters={AgencyLocationPositionRateSettingListFilters}
      exporter={false}
      additionalActions={blockCreateRateSettings ? null : bulkUploadButtons}
      filter={{ active: true }}
    >
      <Datagrid bulkActionButtons={false}>
        <LinkField label="ID" source="id" />
        <LinkField label="Location ID" source="location_id" />
        <LinkField label="Agency ID" source="agency_id" />
        <LinkField label="Position" source="position.display_name" />
        <LinkField label="Specialty" source="specialty.label" sortBy="specialty_id" />
        <MoneyField
          label="Charge rate"
          source="settings.charge_rate_cents"
          blankIfNull={true}
          sortBy="charge_rate_cents"
        />
      </Datagrid>
    </List>
  );
};

AgencyLocationPositionRateSettingList.query = gql`
  query agencyLocationPositionRateSettings($input: AgencyLocationPositionRateSettingQueryInput) {
    _agencyLocationPositionRateSettingsMeta(input: $input) {
      count
    }
    agencyLocationPositionRateSettings(input: $input) {
      id
      location_id
      agency_id
      position_id
      specialty_id
      position {
        id
        display_name
      }
      specialty {
        id
        label
      }
      settings {
        charge_rate_cents
      }
      active
    }
  }
`;

export default AgencyLocationPositionRateSettingList;
